import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    root: {

    },
    marginTop: {
        marginTop: '80px',
        padding: '40px 0',
        height: '80vh',
        [theme.breakpoints.down("md")]: {
            marginTop: '80px',
            padding: '20px 15px',
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: '80px',
            padding: '20px 15px',
        },
    },
    header: {
        fontSize: '25px',
        fontFamily: 'Gilroy-ExtraBold, serif',
        marginBottom: '30px',
        display: 'flext',
        textAlign: 'left',
        width: '100%',
        [theme.breakpoints.down("md")]: {
            fontSize: '25px',
            marginBottom: '20px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '25px',
            marginBottom: '20px',
        },
    },


    para: {
        fontSize: '14px',
        fontFamily: 'Gilroy-Light, serif',
        marginBottom: '15px',
        width: '100%',
        textAlign: 'left',
        [theme.breakpoints.down("md")]: {
            fontSize: '16px',
            marginBottom: '10px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '16px',
            marginBottom: '10px',
        },
    },

    spanText: {
        color: '#D62828',
    },
    img: {
        width: '150px',
        marginBottom: '1.5rem',
    },

    paper: {
        padding: '40px 50px',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: '30px 20px',
        },
    },

    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))
